import { Visualizador } from 'app/main/publico/PDF';
import { publicoApi } from 'app/services/api/publicoApi';
import React from 'react';

async function buscarArquivo(credentials, tenantId, setArquivo) {
  const response = await publicoApi().pedidoVenda(credentials, tenantId);
  setArquivo(response.data.arquivo);
}

const VisualizarPedidoVenda = () => {
  return <Visualizador buscarArquivo={buscarArquivo} nomeArquivo="pedido_venda" />;
};

export default VisualizarPedidoVenda;
